var map = {
	"./ACID-REFLUX.png": 1656,
	"./ACUTE-BRONCHITIS.png": 1657,
	"./ACUTE-GOUT.png": 1658,
	"./ACUTE-PAIN.png": 1659,
	"./ALLERGIES.png": 1660,
	"./BIRTH-CONTROL.png": 1661,
	"./CHRONIC-ASTHMA.png": 1662,
	"./CHRONIC-OBSTRUCTIVE-PULMONARY-DISEASE.png": 1663,
	"./DIABETES-MELLITUS-TYPE-2.png": 1664,
	"./EAR-INFECTION.png": 1665,
	"./FREQUENT-URINATION.png": 1666,
	"./HEADACHE.png": 1667,
	"./HIGH-CHOLESTEROL.png": 1668,
	"./HIV-EXPOSURE.png": 1669,
	"./HTN.png": 1670,
	"./INSOMNIA.png": 1671,
	"./JOCK-ITCH.png": 1672,
	"./MEN-SEXUALLY-TRANSMITTED-DISEASES.png": 1673,
	"./MEN-URINARY-TRACT-INFECTION.png": 1674,
	"./MENSTRUAL-IRREGULARITY.png": 1675,
	"./MOTION-SICKNESS.png": 1676,
	"./OBESITY.png": 1677,
	"./PREMATURE-EJACULATION.png": 1678,
	"./PRESCRIPTION.png": 1679,
	"./PSYCHIATRY.png": 77,
	"./SEXUALLY-TRANSMITTED-DISEASES.png": 1680,
	"./SINUS-INFECTION.png": 1681,
	"./SKIN-INFECTION.png": 1682,
	"./STOMACHACHE.png": 1683,
	"./THYROID-DISEASE.png": 1684,
	"./URINARY-FREQUENCY.png": 1685,
	"./URINARY-TRACT-INFECTION.png": 1686,
	"./VAGINAL-DISCHARGE.png": 1687,
	"./VAGINAL-IRRITATION.png": 1688,
	"./cough.png": 1689,
	"./diarrhea.png": 1690,
	"./nausea-and-vomiting.png": 1691,
	"./oral-thrush.png": 1692,
	"./pink-eye.png": 1693,
	"./sore-throat.png": 1694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1655;